import { usePlayerStore } from "@/features/player/lib/usePlayerStore";
import { observer } from "mobx-react-lite";
import { InteractiveAvatar } from "@/widgets/AvatarSideBar/ui/InteractiveAvatar";
import { RAGQuestion } from "@/widgets/RAGQuestion/ui/RAGQuestion";

export const AvatarSideBar = observer(() => {
    const { selectedSub } = usePlayerStore();
    return (
        <div>
            <h3>Avatar</h3>
            <div>selected subtitle</div>
            <p>{selectedSub?.text}</p>
            <InteractiveAvatar />
            <RAGQuestion />
        </div>
    );
});
